module.exports = "/assets/fc0d64eaaeeb1b04d6ee015180c0837d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cars/assets/logos/ZI.png
// module id = 767
// module chunks = 0